import React from 'react';

function SectionTitle(props) {
    return (
        <div className={`${props.variant === "light" ? "section-title--light" : ""}`}>
            {/* <div style={{width:'10%', height:"5px", backgroundColor:'red', margin:"auto" }}/><br/> */}
            <h6 style={{color:props.txtcolor}}>{props.title}</h6>
            <h2 style={{color:props.txtcolor}}>{props.heading}</h2>
            <div dangerouslySetInnerHTML={{ __html: props.text }} style={{color:"#666"}}></div>
        </div>
    );
}

export default SectionTitle;